// Gotoki button configuration constants
export const GOTOKI_PUBLIC_KEY = "pk_41c8bd7b-8662-4e83-ac4d-fc8c7c808033";
export const GOTOKI_PLAY_IMAGE = "Assets/Playbutton_beyerdynamic.png";
export const GOTOKI_STOP_IMAGE = "Assets/Stop.png";
export const GOTOKI_BUTTON_SIZE = "large";

